<button class="aip-initials" mat-icon-button [matMenuTriggerFor]="menu">
  {{ user["initials"] }}
</button>

<mat-menu #menu="matMenu">
  <div class="user-settings">
    User Settings<br />
    login : {{ user.username }}<br />
    fullname : {{ user.fullname }}<br />
    role : {{ user.usertype }}<br />
  </div>
</mat-menu>

